import { apiCall } from "api-calls/api-call"
import { Formula, CreateFormulaDto, TestFormulaDto, TestFormulaResponseDto } from "../store/types"

export const getAllFormulas = async(): Promise<Formula[]> => {

  return apiCall({
    method: "GET",
    path: "games-v2/formulas",
  })
}

export const getFormulasByGame = async(gameId: string): Promise<Formula[]> => {

  return apiCall({
    method: "GET",
    path: `games-v2/formulas/game/${gameId}`,
  })
}

export const getFormulaById = async(id: string): Promise<Formula> => {

  return apiCall({
    method: "GET",
    path: `games-v2/formulas/${id}`,
  })
}

export const createFormula = async(data: CreateFormulaDto): Promise<Formula> => {

  return apiCall({
    method: "POST",
    path: "games-v2/formulas",
    body: data,
  })
}

export const updateFormula = async(id: string, data: CreateFormulaDto): Promise<Formula> => {

  return apiCall({
    method: "PUT",
    path: `games-v2/formulas/${id}`,
    body: data,
  })
}

export const deleteFormula = async(id: string): Promise<void> => {

  return apiCall({
    method: "DELETE",
    path: `games-v2/formulas/${id}`,
  })
}

export const toggleFormulaActive = async(id: string): Promise<Formula> => {

  return apiCall({
    method: "PATCH",
    path: `games-v2/formulas/${id}/toggle`,
  })
}

export const testFormula = async(data: TestFormulaDto): Promise<TestFormulaResponseDto> => {
  return apiCall({
    method: "POST",
    path: "games-v2/formulas/test",
    body: data,
  })
}

export const validateFormula = async(formula: string): Promise<{ success: boolean; message: string }> => {

  const response: { valid: boolean; error?: string } = await apiCall({
    method: "POST",
    path: "games-v2/formulas/validate",
    body: { formula },
  })

  return {
    success: response.valid,
    message: response.valid ? "Formula is valid" : (response.error || "Formula is invalid"),
  }
}
